import { styled } from '@mui/material';

export const PermissionFormElement = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  rowGap: theme.spacing(3),
  padding: theme.spacing(2),
  '@media (min-width:600px)': {
    padding: theme.spacing(2.5),
  },
}));
